import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useState, useEffect } from 'react';

export default function LoadingWithText(props) {
    const open = props.openLoadingSimpleBackdrop;
    const [dots, setDots] = useState('');

    useEffect(() => {
        if (open) {
            const interval = setInterval(() => {
                setDots(prev => prev.length >= 3 ? '' : prev + '.');
            }, 500);
            return () => clearInterval(interval);
        }
    }, [open]);

    return (
        <div>
            <Backdrop
                sx={{ 
                    color: '#fff', 
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                    flexDirection: 'column',
                    gap: 2
                }}
                open={open}
            >
                <CircularProgress color="inherit" />
                <Typography variant="body1" component="p">
                    Veuillez patienter{dots}
                </Typography>
                <Typography variant="body2" component="p" sx={{ opacity: 0.8 }}>
                    Cette opération peut prendre un peu de temps
                </Typography>
            </Backdrop>
        </div>
    );
}